import { render, staticRenderFns } from "./EmailNotificationSetup.vue?vue&type=template&id=6678912d&scoped=true"
import script from "./EmailNotificationSetup.vue?vue&type=script&lang=js"
export * from "./EmailNotificationSetup.vue?vue&type=script&lang=js"
import style0 from "./EmailNotificationSetup.vue?vue&type=style&index=0&id=6678912d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6678912d",
  null
  
)

export default component.exports